import React, { Component } from 'react';
import Page from '../containers/page';

import {
    Container,
    Row,
    Col,
    Button,
    Modal, ModalBody, ModalFooter
} from 'reactstrap';
import { Document, Page as Pageee, pdfjs } from 'react-pdf';


import { getSearchParams } from '../helpers/linkHelper';
import { API_ENDPOINT } from '../constants';
import { formValueSelector, change } from 'redux-form';  // ES6
import { connect } from 'react-redux';

/**
* PDF Gateway
* @author   Milan Stanojevic
*/
class PdfGateway extends Component {
    constructor(props) {
        super(props);
        if (typeof window != 'undefined')
            pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

        this.state = {
            numPages: 0,
            pageNumber: 1
        };
    }


    onDocumentLoadSuccess = ({ numPages }) => {

        if (this.state.numPages != numPages) {
            this.setState({
                numPages: numPages
            })
        }
    }

    render() {

        const params = getSearchParams(this.props[0].location.search, {});
        const { url } = params;

        if (!url) return null;
        if (!url?.includes('curoflow')) return null;
        return (
            <div className="shame">
                {this.state.error ? null :
                    //<Container>
                    <Row>
                        <Col lg="12">
                            <div className="landing-page-container" /*style={{ minHeight: '100vh'}}*/>
                                <div className="landing-button" style={{ background: 'wight'/*, paddingTop: 0*/ }}>
                                    <Container>
                                        {typeof window != 'undefined' && url ?
                                            <div style={{ width: '100%' }} ref={(node) => this.pdfDocument = node}>

                                                <Document
                                                    file={{ url: url }}
                                                    onLoadSuccess={this.onDocumentLoadSuccess}
                                                    error={"Failed to load PDF file.".translate(this.props.lang)}
                                                    loading={"Loading PDF...".translate(this.props.lang)}
                                                    noData={"No page specified.".translate(this.props.lang)}
                                                >

                                                    {
                                                        Array.from(
                                                            new Array(this.state.numPages),
                                                            (el, index) => (
                                                                <Pageee
                                                                    key={`page_${index + 1}`}
                                                                    pageNumber={index + 1}
                                                                    width={this.pdfDocument ? this.pdfDocument.clientWidth : null}
                                                                />
                                                            )
                                                        )}

                                                </Document>

                                            </div>
                                            :
                                            null}
                                    </Container>
                                </div>

                            </div>
                        </Col>
                    </Row>
                }
            </div >
        );
    }
}

const selector = formValueSelector('modalForm');

export default connect(state => {
    return { selectedWaitingTimeType: selector(state, 'selectedWaitingTimeType') }

}, {
    changeMinValue: value => change("modalForm", "waitingMin", value),
    changeMaxValue: value => change("modalForm", "waitingMax", value),
    changeSelectedWaitingTimeType: value => change("modalForm", "selectedWaitingTimeType", value),

})(Page(PdfGateway));
